<template>
  <div class="footer container-sm">
    <p class="my-3 footer-line">
      <span class="copyright">
        Copyright © {{ currentYear }} Myguard All rights reserved.
      </span>

      <span class="privacy" v-show="$route.path !== '/privacy'">
        <a href="/privacy">{{ $t("Privacy policy") }}</a>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  /* 允許換行：放不下就自然掉到下一行 */
  flex-wrap: wrap;
}

.privacy {
  /* 桌機：正常在右邊 */
  white-space: nowrap;
}

/* ✅ 窄寬時：privacy 掉到下一行就置中 */
@media (max-width: 576px) {
  .footer-line {
    justify-content: center; /* 讓整段置中 */
    text-align: center;
  }

  .privacy {
    flex-basis: 100%;  /* 直接佔滿一行 */
    text-align: center;
  }
}

</style>